import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { clearMetaInfo } from '../../../../components/FormBuilderLibrary/slice';
import ButtonDropdown from '../../../../components/core/ButtonDropdown/ButtonDropdown';

const ActionButton = ({ type, clickedRow }) => {
	const dispatch = useDispatch();
	const [searchParams, setSearchParams] = useSearchParams();
	const isProcess = type === 'Application Process';
	const isForm = !['Application Process', 'Submission Stage', 'Evaluation Stage'].includes(type);

	const Buttons = isProcess
		? {
				title: 'ADD STAGE',
				id: 198567,
				tipPlacement: 'left',
				variant: 'outlined',
				marginBottom: '0px',
				popperPlacement: 'bottom-end',
				tipTitle: !clickedRow?.stageBlockClosed
					? 'Stage Block must be closed with an Evaluation Stage first.'
					: !clickedRow?.hasStages
					? 'Submission Stage must be added as first stage.'
					: 'In order to add a Evaluation Stage, you must first add a Submission Stage.',
				options: [
					{
						disabled: !clickedRow?.stageBlockClosed && clickedRow?.hasStages,
						title: 'Select Submission Stage Template',
						onClick: () => {
							dispatch(clearMetaInfo());
							setSearchParams({
								...searchParams,
								templateSelection: 'submission-stage',
								processId: clickedRow?.process_id
							});
						}
					},
					{
						disabled: !clickedRow?.hasStages,
						title: 'Select Evaluation Stage Template',
						onClick: () => {
							dispatch(clearMetaInfo());
							setSearchParams({
								...searchParams,
								templateSelection: 'evaluation-stage',
								processId: clickedRow?.process_id
							});
						}
					}
				]
		  }
		: {
				title: 'ADD FORM',
				id: 198567,
				tipPlacement: 'left',
				variant: 'outlined',
				marginBottom: '0px',
				popperPlacement: 'bottom-end',
				tipTitle: 'Not available.',
				options: [
					{
						disabled: false,
						title: 'Application Form Template',
						onClick: () => {
							dispatch(clearMetaInfo());
							setSearchParams({ ...searchParams, stageCreation: 'application' });
						}
					}
				]
		  };

	return !isForm && <ButtonDropdown data={Buttons} noDropShadow />;
};

export default ActionButton;
